import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import InfoIcon from "@mui/icons-material/Info";
import ReportIcon from "@mui/icons-material/Report";
import WarningIcon from "@mui/icons-material/Warning";
import clsx from "clsx";
import { Severity } from "constants/Severity";
import { useAppSelector } from "hooks/StoreHooks";
import React, { JSX } from "react";
import { selectNotificationById } from "store/Selectors/notificationSelector";
import ClipBoardTexte from "utils/copyClipboard";
import { displayTimeWithoutDateIfToday } from "utils/displayDateTime";
import "./Notifications.scss";

type Props = {
  notificationId: string;
  handleNotificationDetailClick: () => void;
};

const Notification: React.FC<Props> = ({
  notificationId,
  handleNotificationDetailClick,
}) => {
  const notification = useAppSelector(selectNotificationById(notificationId));

  if (!notification) {
    return null;
  }

  const isRead = !!notification.archivedDate;
  const className = createNotificationClassName(notification.severity, isRead);

  function getAssociatedIcon(): React.ReactNode {
    let icon: JSX.Element = <></>;
    switch (notification?.severity) {
      case Severity.ERROR:
        icon = <ReportIcon />;
        break;
      case Severity.INFO:
        icon = <InfoIcon />;
        break;
      case Severity.SUCCESS:
        icon = <CheckCircleIcon />;
        break;
      case Severity.WARNING:
        icon = <WarningIcon />;
        break;
      default:
        icon = <CircleIcon />;
        break;
    }
    return icon;
  }

  return (
    <div
      className={clsx(
        "notification",
        className,
        `notification-${notification.notificationId}`
      )}>
      <div className={`notification-icon ${notification.severity}`}>
        {getAssociatedIcon()}
      </div>

      <div className="notification-body">
        <div className="notification-time">
          {displayTimeWithoutDateIfToday(notification.sentDate)}
          {notification.archivedDate && (
            <>
              {" "}
              (lu par {notification.archivedBy},{" "}
              {displayTimeWithoutDateIfToday(notification.archivedDate)})
            </>
          )}
        </div>
        <div className="notification-text" onClick={handleNotificationDetailClick}>
          <ClipBoardTexte texte={notification.title} ></ClipBoardTexte>
        </div>
      </div>

      <div className="text-info-icon" onClick={handleNotificationDetailClick}>
        <ArrowForwardIosIcon />
      </div>
    </div>
  );
};

export default React.memo(Notification);

function createNotificationClassName(
  notificationSeverity: string,
  isNotificationRead: boolean
): string {
  return clsx(
    `${notificationSeverity.toLocaleLowerCase()}-notification`,
    isNotificationRead ? "archived-notification" : "active-notification"
  );
}
